<template>
  <v-container fluid class="deleted-payment-page pa-0">
    <v-card :loading="loading" outlined class="deleted-payment-card">
      <div class="list-header">
        <div class="title-wrap">
          <v-btn icon small class="mr-2" @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div>
            <div class="page-title">Deleted Payments</div>
            <div class="page-subtitle">
              {{ Payments.length }} payment{{
                Payments.length === 1 ? "" : "s"
              }}
              found
            </div>
          </div>
        </div>
      </div>

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="mdi-magnify"
          dense
          label="Search payments"
          single-line
          hide-details
          clearable
          class="search-field"
        />

        <v-spacer />

        <DateTimePicker
          defaultRange="since30DaysAgo"
          :range="true"
          v-model="dateTime"
          @submit="getList()"
        />
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="Payments"
          :search="search"
          :loading="loading"
          :sort-desc="sortDesc"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="deleted-payment-table"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer table-row">
              <td class="text-left" @click="viewInvoice(item)">
                {{ item.createdAt | moment("MM/DD/YYYY") }}
              </td>

              <td class="text-left font-weight-bold" @click="viewInvoice(item)">
                {{
                  item.Invoice && item.Invoice.localId
                    ? item.Invoice.localId
                    : "--"
                }}
              </td>

              <td class="text-left" @click="viewInvoice(item)">
                {{
                  item.Invoice &&
                  item.Invoice.Customer &&
                  item.Invoice.Customer.name
                    ? item.Invoice.Customer.name
                    : "--"
                }}
              </td>

              <td class="text-left" @click="viewInvoice(item)">
                <v-chip
                  small
                  color="red lighten-5"
                  text-color="red darken-3"
                  class="font-weight-bold"
                >
                  {{ item.deletedAt | moment("MM/DD/YYYY") }}
                </v-chip>
              </td>

              <td
                class="text-right font-weight-bold"
                @click="viewInvoice(item)"
              >
                {{ item.amount | currency }}
              </td>

              <td class="text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item @click="viewInvoice(item)">
                      <v-list-item-title>View Invoice</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="viewPackingSlip(item)">
                      <v-list-item-title>View Packing Slip</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import Paymentservice from "../service";
// import InvoiceViewLink from "./InvoiceViewLink";
const DateTimePicker = () => import("@/components/DateTimePicker");
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  name: "invoice-list",
  data() {
    return {
      fab: false,
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      createDialog: false,
      selectedPayee: null,
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Invoice #",
          align: "left",
          value: "Invoice.localId",
          sortable: true,
        },
        {
          text: "Customer",
          align: "left",
          value: "Invoice.Customer.name",
          sortable: true,
        },
        {
          text: "Deleted At",
          align: "left",
          value: "deletedAt",
          sortable: true,
        },
        { text: "Amount", align: "right", value: "amount", sortable: true },
        { text: "", align: "right", value: "action", sortable: false },
      ],
      Payments: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "localId",
      pageCount: 0,
      sortDesc: true,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    // this.loadHeader();
    // this.$events.listen("invoiceListEvent", () => this.getList());
    document.title = "smplsale - Deleted Payment List";
  },
  // beforeDestroy() {
  //   this.$events.remove("invoiceListEvent");
  // },
  components: {
    DateTimePicker,
    // InvoiceViewLink
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    viewPackingSlip(payment) {
      const hashId = hashids.encode(payment.Invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/deleted/${hashId}/packingSlip`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewProfile(val) {
      this.$router.push({ path: `/customer/${val.CustomerId}/profile` });
    },
    viewInvoice(payment) {
      const hashId = hashids.encode(payment.Invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/deleted/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },

    getList() {
      this.loading = true;
      let where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
      };
      where.deleted = true;
      // if (this.CustomerId) {
      //   where.CustomerId = this.CustomerId;
      // }

      // if (this.due) {
      //   where.due = true;
      // }

      console.log("deleted", where);

      return Paymentservice.getAllDeletedPaymentDetail(where).then(
        (response) => {
          console.log("getAllPaymentDetail", response);
          this.loading = false;
          this.Payments = response.data;
          return response;
        }
      );
    },
    editInvoice(invoice) {
      // // console.log('ddf', invoice)
      this.$router.push({ path: `/customer/invoice/${invoice.id}/edit` });
    },
    deleteInvoice(invoice) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          Paymentservice.delete(invoice.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Invoice has been deleted.", "success");
                this.getList();
                this.$events.emit("customerProfileEvent");
              }
            })
            .catch((error) => {
              this.$swal({
                title: "Delete Invoice",
                text: error.data.message,
                type: "error",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.deleted-payment-page {
  background: #f8fafc;
  min-height: 100vh;
}

.deleted-payment-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.list-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.title-wrap {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 22px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.15;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.search-field {
  max-width: 360px;
  min-width: 260px;
}

.deleted-payment-table {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.table-row:hover {
  background: #f8fafc;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }

  .search-field {
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .filter-bar {
    padding: 10px;
  }
}
</style>

